<script lang="ts">
  interface Props {
    variant?: "primary" | "secondary";
    margin?: boolean;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { variant = "primary", margin = true, class: className, children }: Props = $props();
</script>

<span
  class="{className} {margin ? 'mb-2' : ''} block font-bold {variant == 'primary'
    ? 'text-H4 sm:text-H3'
    : 'text-H4'}"
>
  {@render children?.()}
</span>
